import { tv } from '~/utils/tv'

export const helperTextRootVariants = tv({
  base: 'flex flex-row items-center justify-start gap-half-pulse text-ellipsis',
})

export const helperTextLabelVariants = tv({
  base: 'line-clamp-2 pl-onepulse text-left font-family-modern font-semibold text-text-neutral',
})

export const helperTextLabelErrorVariants = tv({
  base: 'line-clamp-2 pl-onepulse text-left font-family-modern font-semibold text-text-danger-alternative',
})
